import axios from 'axios'
import store from '@/store/index'
import * as constant from '@/store/constant'
import router from '@/router/index'
import Qs from 'qs'
// import $ from 'jquery'
// import MD5 from 'js-md5';

// axios 配置
axios.defaults.timeout = 60000;
// axios.defaults.baseURL = "http://api.meiduduo.com/shop/";
/*api.meiduduo.com192.168.1.136:8200*/
axios.defaults.baseURL ="https://ailib.hebyun.com.cn/api/"//"http://mediaapi.hebei.com.cn/api/bxdt/index.php/Mobile/Index/"//"http://192.168.91.95/2019/Dproject/bxdt/index.php/Mobile/Index/"//"http://appapi.hebei.com.cn/api/renfang/index.php/Mobile/Index/"//"http://appapi.hebei.com.cn/api/vil/index.php/Mobile/Index/"//"http://192.168.91.95/2019/Bproject/renfang/index.php/Mobile/Index/"//"//"http://192.168.91.76/ecopeople/"//"http://appapi.hebei.com.cn/api/landmark/"//"http://appapi.hebei.com.cn/api/" //constant.API_URL;
axios.defaults.responseType = 'json';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers['Access-Control-Allow-Origin'] = '*';

axios.defaults.transformRequest = [function(params) {
// 	var paramsArr = [];
// 	params['terminalType'] = 'app'
// 	paramsArr = JSON.parse(JSON.stringify(params));
// 	paramsArr.timestamp = (Date.parse(new Date()) + "").substr(0, 10);
// 	var keyArr = [];
// 	var secret = "";
// 	$.each(paramsArr, function(key, value) {
// 		keyArr.push(key);
// 	});
// 	keyArr = keyArr.sort();
// 	var urlPath = "";
// 	$.each(keyArr, function(i, key) {
// 		if (null != paramsArr[key] && "" != $.trim(paramsArr[key])) {
// 			urlPath += key + "=" + paramsArr[key] + "&";
// 			secret += paramsArr[key];
// 		}
// 	});
// 	secret = MD5(secret);
// 	secret = MD5(secret + "meirenhui");
// 	urlPath += "secret=" + secret;
// 	return urlPath;
// //	data = Qs.stringify(data);
// //	return data;
}];
axios.defaults.transformRequest = [function(data) {
  // data.Authorization=`${store.state.token[0].userTokenKey}`;
  data = Qs.stringify(data);
	return data;
}];
// axios.defaults.withCredentials
// =
// true
axios.defaults.data = {
	// _t: '1'
};
axios.defaults.transformResponse = [function(data) {
	// 这里提前处理返回的数

  return data;

}];

axios.defaults.onUploadProgress = [function(progressEvent) {}];
axios.defaults.onDownloadProgress = [function(progressEvent) {}];

// http request 拦截器
axios.interceptors.request.use(
	config => {
		// $(".loading_img").show();
		// config.headers.req_type = 'ajax';


		// if(store.state.token) {
			// var tt1={};
			// tt1.username=`${store.state.token[0].username}`
            // tt1.telephone=`${store.state.token[0].telephone}`
			// tt1.userid=`${store.state.token[0].userid}`
			// tt1.picurl=`${store.state.token[0].picurl}`
			// if(`${store.state.token}`){
                config.headers.Authorization=`${store.state.token}`//encodeURI(JSON.stringify(tt1))
			// }else{
             //    toast({
             //        message:"效验失败，请重新登陆。",
             //        time:3000
             //    });
			// }

			// alert(config.headers.Authorization)

		// }
        // if(store.state.taskid) {
		// 	config.headers.taskid = `${store.state.taskid}`;
		// }
		// config.headers.platform = "shop";
		// config.headers.terminalType = "App";
    // console.log(config)
		return config;
	},
	err => {
		return Promise.reject(err);
	});

// // http response 拦截器
axios.interceptors.response.use(
	response => {
		$(".loading_img").hide();
		return response;
	},
	error => {
		$(".loading_img").hide();
		if(error.response) {
			switch(error.response.status) {
				case 401:
					// 401 清除token信息并跳转到登录页面
					router.replace({
						path: 'login',
						query: {
							redirect: router.currentRoute.fullPath
						}
					});
					break;
				case 1404:
				router.replace({
					path: '/login',
					query: {
						redirect: router.currentRoute.fullPath
					}
				});
//				case 404:
//					// 404
//					router.replace({path: '/404'});
//					break;
//				case 500:
//					// 500
//					router.replace({path: '/500'});
//					break;
//				default:
//					router.replace("/");
			}
		}
		//console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
		try {
			return Promise.reject(error.response.data)
		} catch(e) {}

	});

export default axios;



// WEBPACK FOOTER //
// ./src/axios/index.js


// WEBPACK FOOTER //
// ./src/axios/index.js